import { render, staticRenderFns } from "./AtomTenants.vue?vue&type=template&id=5a1c379e&"
import script from "./AtomTenants.vue?vue&type=script&lang=js&"
export * from "./AtomTenants.vue?vue&type=script&lang=js&"
import style0 from "./AtomTenants.vue?vue&type=style&index=0&id=5a1c379e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports